<div class="card-header">
    <span>
        Spectacle Vendor Details
    </span>
    <button class="btn btn-sm btn-warning float-right" style="margin-top: -4px;" [routerLink]="['/spectacle/vendors']">
        <i class="fa fa-arrow-left"></i> Back
    </button>
</div>

<div class="content-body padding-top-20 padding-bottom-20">
    <div class="row">
        <form #vendorInfoForm="ngForm">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div class=" form-group">
                        <label class="form-label">Vendor Name
                            <span class="mandatory-symbol">*</span>
                        </label>
                        <span class="desc">Vendor Name</span>
                        <div class="controls">
                            <input type="text" (keyup)="validateVendorName()" class="form-control" id="vendorName"
                                name="vendorName" placeholder="Enter vendor name here..." #vendorName="ngModel"
                                [(ngModel)]="vendorInfo.name" required />
                            <div [hidden]="vendorName.valid || vendorName.pristine" class="danger-text">
                                Vendor Name is required
                            </div>
                            <div *ngIf="nameExists" class="danger-text">
                                Vendor Name already exists
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div class=" form-group">
                        <label class="form-label">Vendor Email
                            <span class="mandatory-symbol">*</span>
                        </label>
                        <span class="desc">Contact email address to verify account for onboarding</span>
                        <div class="controls">
                            <input type="email" (keyup)="validateVendorEmail()" class="form-control" id="vendorEmail"
                                name="vendorEmail" placeholder="Enter vendor email here..." #vendorEmail="ngModel"
                                [(ngModel)]="vendorInfo.email" required />
                            <div [hidden]="vendorEmail.valid || vendorEmail.pristine" class="danger-text">
                                Vendor Email Address is required
                            </div>
                            <div *ngIf="emailExists" class="danger-text">
                                Vendor Email Address already exists
                            </div>
                            <div *ngIf="invalidEmailAddress" class="danger-text">
                                Invalid Email Address
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="clear: both;">
                    <div class=" form-group">
                        <label class="form-label">Vendor Mobile
                            <span class="mandatory-symbol">*</span>
                        </label>
                        <span class="desc">Contact mobile number to verify account for onboarding</span>
                        <div class="controls">
                            <input type="text" (keyup)="validateVendorMobile()" class="form-control" id="vendorMobile"
                                pattern="^[0-9]{10}$" name="vendorMobile" placeholder="Enter vendor mobile here..."
                                #vendorMobile="ngModel" [(ngModel)]="vendorInfo.mobile" required />
                            <!-- <div [hidden]="vendorMobile.valid || vendorMobile.pristine" class="danger-text">
                                Vendor Mobile Number is required
                            </div> -->
                            <div *ngIf="mobileExists" class="danger-text">
                                Vendor Mobile Number already exists
                            </div>
                            <div *ngIf="vendorMobile.errors && vendorMobile.dirty" class="danger-text">
                                <div *ngIf="vendorMobile.errors.required">
                                    Vendor Mobile Number is required
                                </div>
                                <div *ngIf="vendorMobile.errors.pattern">
                                    Mobile number must be 10 digits and contain only numbers
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group col-xs-12 text-center space-20 col-xs-12" style="margin-top: 15px;">
                    <input type="hidden" name="g-recaptcha-response" id="g-recaptcha-token">
                    <div id="g-recaptcha-token-v2" class="g-recaptcha"
                        style="width: 100%;align-items: center;justify-content: center;"></div>
                </div>
                <div class="form-group col-xs-12 text-center space-20 col-xs-12" style="margin-top: 15px;">
                    <button
                        [disabled]="mobileExists || nameExists || emailExists || !vendorInfoForm.form.valid || invalidEmailAddress || manualCaptcha"
                        type="button" class="btn btn-raised btn-secondary mr-1" (click)="inviteVendor()">
                        <span style="margin-right:10px;">
                            <i class="fa fa-check-square-o"></i>
                        </span>Add/Invite Vendor</button>
                </div>
            </div>
        </form>
    </div>
</div>